import {debouncer, slideDown, slideToggle, slideUp} from '../utility/utils';
import Dom from '../utility/dom';
import Modal from './accessibility';
import {smoother} from "../utility/gsap";

export const initializeNav = (event) => {
  // Menu Toggle
  const nav = document.querySelector('.main-navigation');
  const menuWrapper = nav.querySelector('.menu-main-navigation-container');
  nav.isOpen = false;
  const menu_toggle = nav.querySelector('.menu-toggle');
  const parentLinks = nav.querySelectorAll('.menu-item-has-children > a');
  
  // Since we don't know the menu breakpoint, check if the menu toggle is visible
  const is_desktop = () => {
    return menu_toggle.offsetParent === null ? true : false;
  }

  // Move contact details into nav container for mobile
  const contact_details = nav.querySelector('.contact_details');
  if(contact_details && menuWrapper){
    menuWrapper.appendChild(contact_details);
    contact_details.classList.add('initialized');
  }

  // Add a wrapping div around all content within menuWrapper
  const menu_content = document.createElement('div');
  menu_content.classList.add('menu-content-wrapper');
  while (menuWrapper.firstChild) {
    menu_content.appendChild(menuWrapper.firstChild);
  }
  menuWrapper.appendChild(menu_content);

  menu_toggle.addEventListener('click', function(e){
    if(!nav.isOpen){
      menuOpen();
    }
    else {
      menuClose();
    }
  });

  if(parentLinks.length > 0){
    parentLinks.forEach(link => {
      link.addEventListener('click', function(e){
        // only worried about mobile
        if(is_desktop()) return;

        const parent_li = link.parentElement;
        const sub_menu = link.nextElementSibling;

        // If the sub-menu is already open, allow the link to work as normal 
        if(!sub_menu || sub_menu.style.display === 'block') return;
        e.preventDefault();

        // If there are other sub-menus open, close them.
        close_active_li_els();

        // Slide down this one
        slideDown(sub_menu, 300);
        parent_li.classList.add('active');
      });
    });
  }

  const menuClose = () => {
    nav.isOpen = false;
    // Set closing class for css animation help
    nav.classList.add('closing');
    const navItems = nav.querySelectorAll('li');
    navItems.forEach(item => {
      item.classList.add('closing');
    });
    setTimeout(()=>{
      nav.classList.remove('closing');
      navItems.forEach(item=>{
        item.classList.remove('closing');
      })
    }, 700);
    
    // Set Active Class
    nav.classList.remove('toggled');
    menu_toggle.innerHTML = 'Menu';
    menu_toggle.classList.remove('active');
    menu_toggle.blur();
    Dom.body.classList.remove('scroll-lock');
    if(smoother){
      smoother.paused(false);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'false');

    // Handle focus trapping
    Modal.close(nav);
    menu_toggle.setAttribute('tabindex', '1');

    close_active_li_els();
  }

  const menuOpen = () => {
    nav.isOpen = true;

    // Set Active Class
    nav.classList.add('toggled');
    menu_toggle.innerHTML = 'Close';
    menu_toggle.classList.add('active');
    menu_toggle.blur();
    Dom.body.classList.add('scroll-lock');
    if(smoother){
      smoother.paused(true);
    }

    // Set Aria Hidden Attribute
    menu_toggle.setAttribute('aria-expanded', 'true');

    // Handle focus trapping
    Modal.open(nav);

    // Call window resize to update css custom properties for window width
    window.dispatchEvent(new Event('resize'));
  }

  const close_active_li_els = (e) => {
    const active_items = nav.querySelectorAll('li.active');
    active_items.forEach(item => {
      item.classList.remove('active');
      const sub_menu = item.querySelector('ul.sub-menu');
      if(sub_menu){
        slideUp(sub_menu, 300);
        setTimeout(()=>{
          sub_menu.style.display = '';
        }, 300);
      }
    });
  }

  // Set menu state on load and resize if changing from mobile to desktop.
  const set_menu_state = () => {
    // Desktop
    if(is_desktop()){
      if(!nav.classList.contains('is_desktop')){
        nav.classList.add('is_desktop');
        nav.classList.remove('is_mobile');
      }

      // if mobile state classes are present, remove them.
      if(nav.classList.contains('toggled')){
        menuClose();
        Modal.setToFocusable(nav);
      }

      close_active_li_els();

      // set aria-hidden if not already set to false
      if(menu_toggle.getAttribute('aria-expanded') !== 'true'){
        menu_toggle.setAttribute('aria-expanded', 'true');
      }
    }
    // Mobile
    else {
      if(!nav.classList.contains('is_mobile')){
        nav.classList.remove('is_desktop');
        nav.classList.add('is_mobile');
      }
      
      // set aria-hidden if not already set to true and if menu isn't currently active
      if(!nav.classList.contains('toggled') && menu_toggle.getAttribute('aria-expanded') !== 'false'){
        menu_toggle.setAttribute('aria-expanded', 'false');
      }
    }
  }
  set_menu_state();

  // Resize modals on window resize
  window.addEventListener('resize', debouncer(function(){
    set_menu_state();
  }, 15));
};
